



















import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import Loading from "@/components/Loading.vue";
import BlurredTenant from "@/components/BlurredTenant.vue";

export default Vue.extend({
  components: { Loading, BlurredTenant },
  data() {
    return {
      showBlur: userManager.checkRole(["cpoAdmin", "cpoMonitor"], true) && !!userManager.getUserInfo().tenant?.setting?.expDate && userManager.getUserInfo().tenant.setting.expDate < new Date().getTime(),
      self: this,
      userManager,
      loading: false,
      tenantSetting: {},
      point: 0,
      addPointBtnOptions: null,
      tableOptions: {
        attrs: {
          "item-key": "_id",
          "sort-by": "time",
          "sort-desc": true,
        },
        content: {
          name: "Promotion Transactions",
          urlEnabled: true,
          search: {
            ext: {
              hidden: true,
            },
          },
          filters: {
            filters: {
              tenantId: userManager.checkRole(["systemAdmin", "admin"]) && {
                type: "XAutocomplete",
                attrs: {
                  label: "Organization",
                  required: true,
                  "item-value": "_id",
                  "item-text": "name",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("tenants", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            orderBy: "name",
                            orderType: "asc",
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  equal_to: {},
                },
              },
              userId: {
                  type: "XAutocomplete",
                  attrs: {
                      label: "User",
                      required: true,
                      "item-value": "_id",
                      "item-text": "email",
                      xOptions: {
                          content: {
                              async itemsSuggestor(search, value, limit) {
                                  const { items } = await coreApiClient.call("users", "findAllUser", {
                                      payload: JSON.stringify({
                                          limit,
                                          search,
                                          orderBy: "email",
                                          orderType: "asc",
                                          filters: [
                                              {
                                                  key: "_id",
                                                  operator: "equal_to",
                                                  value,
                                              },
                                          ],
                                          extraParams: {
                                              searchCrossTenant: !!search && true
                                          }
                                      }),
                                  });
                                  return items;
                              },
                          },
                      },
                  },
                  rules: {
                      equal_to: {},
                  },
              },
            },
          },
          displayFields: {
            time: {
              text: "Paid Time",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            promotion: {
              text: "Promotion",
              sortable: true,
              options: {
                transform: (value, item) => {
                   return item.promotionSnapshot ? item.promotionSnapshot?.promotionSettingItems[0].promotionValue + '%' : 'N/A';
                }
              },
            },
            amount: {
              text: "Amount",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            point: {
              text: "After Discount",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            paymentMethod: {
              text: "Payment Method",
              sortable: true,
              options: {
                transform: (value, item) => {
                  // first letter uppercase
                  const method = value?.name || item?.paymentMethodType; 
                  return method?.charAt(0).toUpperCase() + method?.slice(1);
                },
                label: true,
              },
            },
            transactionRef: {
              text: "Transaction Ref",
              options: {
                // subProp: "details.vnp_BankTranNo",
                transform: (value, item) => {
                  // first letter uppercase
                  const method = value?.name || item?.paymentMethodType;
                  if (method == "voucher") {
                    return item?.details?.voucherCode;
                  }
                  return item?.details?.vnp_BankTranNo;
                },
              },
            },
            user: userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor"]) && {
              text: "User",
              options: {
                subProp: "user.email",
                label: true,
                sortBy: "userId",
              },
            },
            tenant: userManager.checkRole(["systemAdmin", "admin"]) && {
              text: "Organization",
              options: {
                subProp: "tenant.name",
                label: true,
                sortBy: "tenantId",
              },
            },
            action: {
              text: "Actions",
              hidden: true,
            },
          },
          topActionButtons: {
            export: userManager.checkRole([
              "systemAdmin",
              "admin",
            ]) && {
              content: {
                text: "Export all",
                icon: "mdi-microsoft-excel",
              },
              on: {
                  xClick({ self }) {
                    const dataTable = self.context();
                    coreApiClient.download(
                      "paymentTransactions",
                      `@/export/with-promotion`,
                      dataTable.getFindAllOptions()
                    );
                  },
              },
            },
          },
          findAllOptionsFilter(options) {
            const id = this.$route.params.id;
            options.filters.push({
              key: "promotionSnapshot._id",
              operator: "equal_to_id",
              value: id,
            });
            options.filters.push({
              key: "status",
              operator: "equal_to",
              value: "success",
            });
            return options;
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const { items, count } = await coreApiClient.call("paymentTransactions", "findAll", options);
              return [items, count];
            },
          },
        },
      },
    };
  },
  methods: {
   
  }
});
